<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <!-- <p class="imgItem1">Chính sách bảo mật</p> -->
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import importedImg1 from "@/page/commuyservices/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      importedImg1: importedImg1,
      text: `Bienvenido al sitio web y a los servicios de COMMU Y SERVICES S.A.S (en adelante la “Compañía”). La Compañía se compromete a proteger su privacidad y garantizar que su información personal sea tratada de forma segura. Esta Política de privacidad explica cómo recopilamos, usamos, almacenamos y protegemos su información.

1. Recopilación de información
Cuando utiliza nuestros servicios, podemos recopilar los siguientes tipos de información:

1.1 Información proporcionada directamente
Información que usted proporciona cuando se comunica con nosotros o se registra para nuestros servicios, como: nombre, correo electrónico, número de teléfono, nombre de la empresa, etc.

Solicitudes comerciales o comentarios que nos envíe.

1.2 Información recopilada automáticamente
Información del dispositivo: cuando visita nuestro sitio web, podemos recopilar información como el tipo de dispositivo, el sistema operativo, el tipo de navegador, etc.

Datos de registro: incluida la dirección IP, el tiempo de acceso, las páginas visitadas, el comportamiento de los clics, etc.

Cookies y tecnologías de seguimiento: Podemos utilizar cookies o tecnologías similares para optimizar su experiencia.

2. Uso de la información
La información que recopilamos puede utilizarse para los siguientes fines:

Proporcionar y optimizar nuestros servicios (incluyendo atención al cliente, marketing saliente, investigación de mercado, etc.).

Mejorar la experiencia del usuario (analizar el comportamiento del usuario y optimizar los métodos de interacción).

Comunicaciones y promociones (enviarle notificaciones de servicios relevantes o información de marketing, puede optar por no participar en cualquier momento).

Seguridad y cumplimiento (prevención de fraude, mantenimiento de la seguridad del sitio web, cumplimiento de obligaciones legales).

3. Intercambio de información
La Compañía no venderá ni alquilará su información personal a terceros no autorizados, pero podrá compartirla en las siguientes circunstancias:

Socios comerciales: Para brindar un mejor servicio al cliente, podemos compartir los datos necesarios con socios de confianza, pero solo según sea necesario para fines comerciales.

Requisitos legales: Es posible que necesitemos divulgar su información si así lo exige la ley o lo solicita la policía.

Transferencias comerciales: En el caso de una fusión, adquisición o transferencia de activos de nuestra empresa, su información puede ser uno de los activos transferidos.

4. Almacenamiento y seguridad de datos
Tomamos medidas técnicas y administrativas razonables para proteger sus datos contra acceso, divulgación o alteración no autorizados.

Solo conservamos su información personal durante el tiempo que sea necesario y eliminaremos o anonimizaremos los datos periódicamente según lo exija la ley.

5. Sus derechos
Puede ejercer los siguientes derechos con respecto a su información personal:

Acceso y corrección: Puede solicitar ver la información que tenemos sobre usted y solicitar que se corrija la información inexacta.

Solicitud de eliminación: En determinadas circunstancias, puede solicitarnos que eliminemos su información personal.

Exclusión de marketing: puede optar por no recibir nuestras comunicaciones de marketing en cualquier momento.

Si necesita ejercer sus derechos, contáctenos a [correo electrónico de contacto de la empresa].

6. Cookies y tecnologías de seguimiento
Podemos utilizar cookies para mejorar la experiencia del usuario. Puede configurar o desactivar las cookies en la configuración de su navegador. Sin embargo, deshabilitarla puede afectar el uso de algunas funciones.

7. Enlaces de terceros
Nuestro sitio web puede contener enlaces a sitios web de terceros cuyas políticas de privacidad pueden ser diferentes y no somos responsables de su contenido o prácticas de privacidad.

8. Actualizaciones de la política de privacidad
Podemos actualizar esta Política de Privacidad periódicamente para reflejar requisitos legales o cambios en la empresa. La versión más reciente se publicará en esta página. Revísela periódicamente.

Gracias por confiar en COMMU Y SERVICES S.A.S. ¡Seguiremos comprometidos con la protección de su privacidad!`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3200px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: -80px;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -170px auto 100px;
  height: 2200px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  border: 2px solid #D795FF;
  border-radius: 12px;
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4D64E4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
